import PageAdditionalControls from './PageAdditionalControlsContainer';

export default PageAdditionalControls;